import { Modal } from "@pacificoseguros/pixie/react/modal";
import React, { memo } from "react";
import iconGenericError from "../../assets/icons/ic-hearth.svg";
import { Column } from "../../components/layout/flex-layout";
import { SizedBox } from "../../components/layout/sized-box";
import { SpacingBox } from "../../components/layout/spacing-box";
import { Typography } from "../../components/typography/typography";
import { DatalayerModal } from "../../libs/datalayer/components/datalayer-modal";
import { DatalayerModalPixieButton } from "../../libs/datalayer/components/datalayer-modal-pixie-button";
import { useCustomerAlreadyHasPolicyPopup } from "./hooks/use-customer-already-has-policy-popup";

const CustomerAlreadyHasPolicyPopup = () => {
    const { opened, close } = useCustomerAlreadyHasPolicyPopup();
    return (
        opened && (
            <DatalayerModal
                open={opened}
                onClose={close}
                as={Modal}
                type="Error"
                name="Cliente con seguro"
            >
                <SpacingBox pt={30} pb={10}>
                    <Typography textAlign="center" as="div" fontSize={16}>
                        <SizedBox width={280}>
                            <Column align="center">
                                <img
                                    src={iconGenericError}
                                    alt="error generico"
                                />
                            </Column>
                            <SpacingBox mb={27} />
                            <Typography fontSize={20}>
                                <b>¡Hola!</b>
                            </Typography>
                            <SpacingBox mb={17} />
                            <div>
                                Vemos que ya tienes un seguro de<br></br>
                                Vida Ley con nosotros.{" "}
                                <b>
                                    Si deseas<br></br>declarar tu planilla,
                                </b>{" "}
                                contáctate con<br></br>nuestro centro de
                                información y<br></br>consultas.
                            </div>
                            <SpacingBox mb={26} />
                            <a href="tel:015135000">
                                <Typography
                                    variant="secondary"
                                    decoration="underline"
                                    fontSize={24}
                                >
                                    01 513 5000
                                </Typography>
                            </a>
                            <SpacingBox mb={26} />
                            <DatalayerModalPixieButton
                                kind="secondary"
                                inverse
                                fluid
                                onClick={close}
                                label="Finalizar"
                            >
                                Finalizar
                            </DatalayerModalPixieButton>
                        </SizedBox>
                    </Typography>
                </SpacingBox>
            </DatalayerModal>
        )
    );
};

export default memo(CustomerAlreadyHasPolicyPopup);
